import { ICoordinates, IServiceDesignatedHotspot } from '../types'
import { IAutoCompleteRequestDTO } from '../types/google-map'
import { googleMapService } from '../services/GoogleMap'

interface IValidateMarkerPosition {
  dragEvent: google.maps.MouseEvent
  location: IServiceDesignatedHotspot
}

export const searchLocation = (query: IAutoCompleteRequestDTO) => {
  return googleMapService.getPlacePredictions(query).then((googleLocations: any) => {
    console.log(googleLocations)
    const data = googleLocations.map((location: any) => ({
      googlePlaceId: location.place_id,
      fullAddress: `${location.structured_formatting.main_text}, ${location.structured_formatting.secondary_text}`
    }))
    return data
  })
}

export const getPlaceDetails = (placeId: string) => {
  return googleMapService.getPlaceDetails(placeId).then(parsePlaceData)
}

function parsePlaceData(placeData: any) {
  const parsedLocation: any = {}
  const coordinates: any = {}
  let street = ''
  Object.keys(placeData).forEach(geoProperty => {
    if (geoProperty === 'address_components') {
      placeData[geoProperty].forEach((addressComponent: any) => {
        if (addressComponent.types.includes('administrative_area_level_1')) {
          parsedLocation.state = addressComponent.long_name
        }
        if (addressComponent.types.includes('country')) {
          parsedLocation.country = addressComponent.long_name
        }
        if (addressComponent.types.includes('postal_code')) {
          parsedLocation.zip = addressComponent.long_name
        }
        if (
          addressComponent.types.includes('political') &&
          (addressComponent.types.includes('locality') ||
            addressComponent.types.includes('administrative_area_level_1'))
        ) {
          parsedLocation.city = addressComponent.long_name
        }
        if (addressComponent.types.includes('street_number')) {
          const streetNumber = addressComponent.long_name
            ? addressComponent.long_name + ' '
            : addressComponent.short_name
            ? addressComponent.short_name + ' '
            : ''
          street += streetNumber
          parsedLocation.streetNumber = streetNumber
        }
        if (addressComponent.types.includes('route')) {
          street += addressComponent.long_name + ' '
        }
        if (addressComponent.types.includes('sublocality_level_2')) {
          street += addressComponent.long_name + ' '
        }
      })
    }
    if (geoProperty === 'name') {
      parsedLocation.placeName = placeData[geoProperty]
    }
    if (geoProperty === 'geometry') {
      if (placeData[geoProperty].location) {
        coordinates.lng = placeData[geoProperty].location.lng()
        coordinates.lat = placeData[geoProperty].location.lat()
      }
    }
  })
  parsedLocation.street = street
  parsedLocation.unit = ''
  parsedLocation.timeZone = ''
  return { ...parsedLocation, coordinates }
}

// returns displacement between 2 locations in meters
export const displacementBetween = (
  origin: {
    lat: number
    lng: number
  },
  destination: {
    lat: number
    lng: number
  }
) => {
  // generally used geo measurement function
  const R = 6378.137 // Radius of earth in KM
  const dLat = (destination.lat * Math.PI) / 180 - (origin.lat * Math.PI) / 180
  const dLon = (destination.lng * Math.PI) / 180 - (origin.lng * Math.PI) / 180
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((origin.lat * Math.PI) / 180) *
      Math.cos((destination.lat * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = R * c
  return d * 1000 // meters
}

export const validateMarkerPosition = ({ dragEvent, location }: IValidateMarkerPosition) => {
  const { shape: polygon } = location
  const polygonCoordinates =
    polygon && polygon.coordinates && polygon.coordinates[0] && polygon.coordinates[0][0]
      ? polygon.coordinates[0][0].map(coordinate => ({ lat: coordinate[1], lng: coordinate[0] }))
      : null

  if (polygonCoordinates) {
    const hotspotZone = new google.maps.Polygon({ paths: polygonCoordinates })
    return google.maps.geometry.poly.containsLocation(dragEvent.latLng, hotspotZone) ? true : false
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/location.ts